import type { ReactNode } from "react";
import { PrimaryButton } from "./ui";
import "./AuthSubmit.css";

/** Submit button of an auth form. While `busy` a sheen runs across it instead
 *  of the flat disabled look. Forms that gate submission pass `ready`: the
 *  button then fades up and pulses once at the moment it becomes usable. */
export function AuthSubmit({
  busy = false,
  ready,
  children,
}: {
  busy?: boolean;
  ready?: boolean;
  children: ReactNode;
}) {
  const className =
    "auth-submit" +
    (busy ? " auth-submit--busy" : "") +
    (ready ? " auth-submit--armed" : "");
  return (
    <PrimaryButton
      type="submit"
      className={className}
      disabled={busy || ready === false}
      aria-busy={busy}
    >
      {children}
    </PrimaryButton>
  );
}
